import initialState from '../initialState';
import * as types from './actionTypes.corpus';

const initialStateObj = {
    ...initialState.corpus,
};

export default function CorpusReducer(state = initialStateObj, action) {
    switch (action.type) {

        case types.GET_CORPUSE_REQ:
        case types.CLEAR_CORPUS_INFO_REQ:
            return {
                ...state,
                ...{
                    corpusId: null,
                    document: null,
                    title: null,
                    file: null,
                    corpusSearchQuery: '',
                    searchedDocuments: null,
                    selectedDocument: null,
                    searchInProcess: false
                },
            };

        case types.GET_CORPUSE_OK:
            return {
                ...state,
                ...{ corpusId: action.corpusId, title: action.title, file: action.file, document: null, documents: action.documents },
            };

        case types.GET_CORPUSE_DOCUMENT_REQ:
            return {
                ...state,
                ...{ document: null },
            };

        case types.GET_CORPUSE_DOCUMENT_OK:
            return {
                ...state,
                ...{
                    document: { content: action.content, meta: action.meta }
                }
            };

        case types.SEARCH_BY_CORPUSE_REQ:
        case types.CLEAR_CORPUS_SEARCH_REQ:

            return {
                ...state,
                ...{
                    searchInProcess: true,
                }
            };

        case types.SEARCH_BY_CORPUSE_OK:
            return {
                ...state,
                ...{
                    corpusSearchQuery: action.corpusSearchQuery,
                    corpusSearchQustion: action.corpusSearchQustion,
                    corpusMaxTokens: action.corpusMaxTokens,
                    searchedDocuments: [...action.searchedDocuments],
                    searchInProcess: false,
                }
            };

        case types.SEARCH_BY_CORPUSE_ERR:
            return {
                ...state,
                ...{
                    searchInProcess: false,
                    searchedDocuments: null,
                }
            };

        case types.CLEAR_CORPUS_SEARCH_OK:
            return {
                ...state,
                ...{
                    corpusSearchQuery: '',
                    corpusSearchQustion: '',
                    corpusMaxTokens: 0,
                    searchInProcess: false,
                    searchedDocuments: null,
                    selectedDocumentInSearch: null,
                }
            };

        case types.SELECT_CORPUS_DOCUMENT_REQ:
            return {
                ...state,
                ...{
                    document: null,
                    searchInProcess: false,
                }
            };

        case types.SELECT_CORPUS_DOCUMENT_IN_SEARCH_OK:
            return {
                ...state,
                ...{
                    selectedDocumentInSearch: action.selectedDocument,
                }
            };

        case types.SELECT_CORPUS_DOCUMENT_OK:
            return {
                ...state,
                ...{
                    selectedDocument: action.selectedDocument,
                }
            };

        default:
            return state;
    }
}